import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7afc54e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col-12 p-md-12" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "tendetai",
  style: {"font-weight":"bold","width":"50vw"}
}, "Tên đề tài :", -1))
const _hoisted_5 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "masodetai" }, "Mã số đề tài", -1))
const _hoisted_7 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nguoiThucHien1" }, "Người thực hiện 1", -1))
const _hoisted_9 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nguoiThucHien2" }, "Người thực hiện 2", -1))
const _hoisted_11 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nguoiThucHien3" }, "Người thực hiện 3", -1))
const _hoisted_13 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "linhVuc" }, "Lĩnh vực", -1))
const _hoisted_15 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "chuyenNganh" }, "Chuyên ngành", -1))
const _hoisted_17 = { class: "p-field p-col-12 p-sm-4 p-md-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "capDo" }, "Cấp độ đề tài", -1))
const _hoisted_19 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Nội dung:", -1))
const _hoisted_21 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_22 = { class: "p-fluid" }
const _hoisted_23 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_24 = { class: "p-field p-col-6 p-md-6" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Nhận xét:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_27 = { style: {"color":"salmon"} }
const _hoisted_28 = {
  key: 0,
  class: "p-field p-col-6 p-md-6"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Tập tin:", -1))
const _hoisted_30 = {
  key: 1,
  class: "p-field p-col-6 p-md-6"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-weight":"bold"} }, "Tập tin đính kèm mới:", -1))
const _hoisted_32 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-field p-col-12 p-sm-12 p-md-12" }, null, -1))
const _hoisted_34 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_35 = { class: "p-field p-col-2 p-sm-2 p-md-2" }
const _hoisted_36 = { enctype: "multipart/form-data" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = { class: "p-field p-col-12 p-sm-12 p-md-12" }
const _hoisted_39 = { id: "loading" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Đang gởi lại đề tài", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_lv = _resolveComponent("lv")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_panel = _resolveComponent("panel")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, {
      style: {"text-align":"center"},
      header: "Đề tài bị từ chối"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_InputText, {
                id: "tendetai",
                type: "phone",
                modelValue: $setup.deTai.tenDeTai,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.deTai.tenDeTai) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_InputText, {
                id: "masodetai",
                type: "text",
                modelValue: $setup.deTai.maSoDeTai,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.deTai.maSoDeTai) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_InputText, {
                id: "nguoiThucHien1",
                type: "text",
                modelValue: $setup.deTai.nguoiThucHien1,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.deTai.nguoiThucHien1) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_InputText, {
                id: "nguoiThucHien2",
                type: "text",
                modelValue: $setup.deTai.nguoiThucHien2,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.deTai.nguoiThucHien2) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_InputText, {
                id: "nguoiThucHien3",
                type: "phone",
                modelValue: $setup.deTai.nguoiThucHien3,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.deTai.nguoiThucHien3) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_InputText, {
                id: "linhVuc",
                type: "phone",
                modelValue: $setup.deTai.linhVuc,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.deTai.linhVuc) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_InputText, {
                id: "chuyenNganh",
                type: "phone",
                modelValue: $setup.deTai.chuyenNganh,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.deTai.chuyenNganh) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createVNode(_component_InputText, {
                id: "capDo",
                type: "phone",
                modelValue: $setup.deTai.capDoDeTai,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.deTai.capDoDeTai) = $event)),
                style: {"text-align":"center"},
                readonly: ""
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", null, [
                _createVNode(_component_Textarea, {
                  id: "noidung",
                  type: "phone",
                  modelValue: $setup.deTai.noiDungDeTai,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.deTai.noiDungDeTai) = $event)),
                  rows: "20"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_panel, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.nhanXet, (nx) => {
                          return (_openBlock(), _createBlock(_component_lv, null, {
                            default: _withCtx(() => [
                              _hoisted_26,
                              _createElementVNode("label", null, "Nhận xét lần(" + _toDisplayString(nx.lanDuyetDeTai) + "): ", 1),
                              _createElementVNode("label", null, _toDisplayString(nx.noiDung) + " - ", 1),
                              _createElementVNode("label", _hoisted_27, _toDisplayString(nx.tenNguoiNhanXet), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 256))
                      ]),
                      ($setup.listFile.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                            _hoisted_29,
                            _createVNode(_component_DataTable, {
                              value: $setup.listFile,
                              showGridlines: "",
                              style: {"font-size":"13px"},
                              class: "p-datatable-sm",
                              responsiveLayout: "scroll"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "nameFile",
                                  header: "Tên"
                                }),
                                _createVNode(_component_Column, {
                                  header: "",
                                  style: {"width":"20px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    (slotProps.data.value)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          class: "p-button-raised p-button-secondary",
                                          label: "Tải",
                                          icon: "pi pi-download",
                                          onClick: ($event: any) => ($setup.downLoadFile(slotProps.data.value)),
                                          style: {"font-size":"13px"}
                                        }, null, 8, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]))
                        : _createCommentVNode("", true),
                      ($setup.listFileName.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode(_component_DataTable, {
                              value: $setup.listFileName,
                              showGridlines: "",
                              style: {"font-size":"13px"},
                              class: "p-datatable-sm",
                              responsiveLayout: "scroll"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Column, {
                                  field: "nameFile",
                                  header: "Tên"
                                }),
                                _createVNode(_component_Column, {
                                  header: "",
                                  style: {"width":"20px"}
                                }, {
                                  body: _withCtx((slotProps) => [
                                    _createVNode(_component_Button, {
                                      class: "p-button-danger",
                                      label: "Xóa",
                                      icon: "pi pi-trash",
                                      onClick: ($event: any) => ($setup.deleteFile(slotProps.data.nameFile)),
                                      style: {"font-size":"13px"}
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_Button, {
                          class: "p-button-outlined",
                          label: "Đính kèm tập tin",
                          onclick: "document.getElementById('myFile').click()",
                          icon: "pi pi-paperclip",
                          style: {"margin-right":"2vw","width":"15vw"}
                        })
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_Button, {
                label: "Gởi lại đề tài",
                type: "button",
                icon: "pi pi-check",
                align: "center",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.goiLaiDeTai())),
                disabled: $setup.loadingBar,
                style: {"width":"15vw","margin-right":"2vw"}
              }, null, 8, ["disabled"])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("form", _hoisted_36, [
                _createElementVNode("input", {
                  id: "myFile",
                  type: "file",
                  style: {"display":"none"},
                  accept: ".xls,.xlsx,.doc,.docx,.pdf",
                  name: "files",
                  multiple: "multiple",
                  onChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.fileChange($event.target.files))),
                  disabled: $setup.loadingBar
                }, null, 40, _hoisted_37)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_Dialog, {
        header: "Gởi chỉ đạo",
        visible: $setup.loadingBar,
        "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (($setup.loadingBar) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createVNode(_component_ProgressBar, {
              mode: "indeterminate",
              style: {"height":".3em"}
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_component_ConfirmDialog)
    ])
  ], 64))
}